export default {
  computed: {
    getLocale() {
      return this.$i18n.locale
    },
    isUSALoginOrLocation() {
      return this.getLocale === 'en-US'
    },
    isAUSLoginOrLocation() {
      return this.getLocale === 'en-AU'
    },
    isNZLoginOrLocation() {
      return this.getLocale === 'en-NZ'
    },
    isUKLoginOrLocation() {
      return this.getLocale === 'en-GB'
    },
  },
}
